export default __webpack_public_path__ + "static/media/betting.774ea3e0.svg";